import React, { Component } from 'react'
import { connect } from 'react-redux'
import RequiredSelect from '../../common/form/elements/required-select'
import SectionTitle from '../../common/section-title'
import { getOrderToConfirm } from '../../../actions/orders'
import RestartOrder from "../restart-order";

class DeliveryAddress extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedOutlet: undefined
    }
  }

  componentDidMount() {
    if (this.props.features['new_ordering'] && this.props.deliveryAddress) {
      this.loadOutletDetails(this.props.deliveryAddress.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.features['new_ordering'] && (!!this.props.outlets.length !== !!prevProps.outlets.length) && this.props.deliveryAddress) {
        this.loadOutletDetails(this.props.deliveryAddress.id);
    }
  }

  loadOutletDetails = (value) => {
    let selectedStore = this.props.outlets.find(outlet => outlet.id === value.toString());
    this.setState({ selectedOutlet: selectedStore });
    this.props.dispatch(getOrderToConfirm(true, value));
  };

  render() {
    const { selectedOutlet } = this.state;
    return (
      <div>
        <SectionTitle>Delivery address</SectionTitle>
        { !this.props.features['new_ordering'] &&
        <div>
          <RequiredSelect
            model=".outlet_id"
            values={this.props.outlets}
            labelAttr="attributes.name"
            valueAttr="id"
            onChange={this.loadOutletDetails} />
        </div>
        }
        {
          selectedOutlet &&
          <div>
            {this.props.features['new_ordering'] &&
            <div>
              {selectedOutlet.attributes['name']} - {selectedOutlet.attributes['customer-number']}
              <br />
            </div>
            }
            <div>{selectedOutlet.attributes['address-1']}</div>
            <div>{selectedOutlet.attributes['address-2']}</div>
            <div>{selectedOutlet.attributes['address-3']}</div>
            <div>{selectedOutlet.attributes.town}</div>
            <div>{selectedOutlet.attributes.county}</div>
            <div>{selectedOutlet.attributes.eircode}</div>
          </div>
        }
        {this.props.features['new_ordering'] && <RestartOrder />}
      </div>
    )
  }
}

export default connect()(DeliveryAddress);



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/delivery-address.jsx